import React from "react";
import ReactDOM from "react-dom";
import "./styles/Modal.css";

function Modal(props) {
  if (!props.isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className="modal">
      <div className={`modal-dialog${props.large ? " modal-dialog--large" : ""}`}>
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">{props.title}</h4>
            <button
              type="button"
              onClick={props.onClose}
              className="modal_close-button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">{props.children}</div>
        </div>
      </div>
    </div>,
    document.getElementById("modal")
  );
}

export default Modal;
